<script setup>
import { StatusEnum } from "@/utilities/enum";
import moment from "moment-timezone";
moment.locale("id");
</script>

<template>
  <div
    class="w-full p-3 rounded-md shadow-md"
    :class="[
      isCurrentYear &&
      (data.active || data.urgent) &&
      data.status !== StatusEnum.COMPLETED &&
      data.status !== StatusEnum.WAITING_APPROVAL &&
      !isPjo
        ? 'border-[2px] border-red-500'
        : 'border-[2px] border-gray-300',
    ]"
  >
    <div class="flex justify-between items-center">
      <div class="flex gap-2 items-center justify-start">
        <img
          src="../../../assets/icon/calendar.png"
          alt="icon-calendar"
          loading="eager"
          class="w-6"
        />
        <h3 class="text-sm font-medium text-gray-800">
          {{ data.name }}
        </h3>
      </div>
      <v-btn
        class="capitalize w-32 text-[11px]"
        :class="[
          isCurrentYear &&
          (data.active || data.urgent) &&
          data.status !== StatusEnum.COMPLETED &&
          data.status !== StatusEnum.WAITING_APPROVAL &&
          !isPjo
            ? 'border-red-500 text-red-600'
            : 'border-gray-400 text-gray-500',
          isCurrentYear && !data.active && !data.urgent
            ? 'cursor-not-allowed'
            : 'cursor-pointer',
        ]"
        variant="outlined"
        @click="goToReport(data)"
      >
        Detail
        <template v-slot:append>
          <div
            class="w-5 h-5 flex justify-center items-center rounded-md"
            :class="[
              isCurrentYear &&
              (data.active || data.urgent) &&
              data.status !== StatusEnum.COMPLETED &&
              data.status !== StatusEnum.WAITING_APPROVAL &&
              !isPjo
                ? 'bg-red-600'
                : 'bg-gray-400',
            ]"
          >
            <v-icon class="text-white text-sm"> mdi-arrow-right </v-icon>
          </div>
        </template>
      </v-btn>
    </div>
    <hr class="my-3 border-dashed" />
    <div class="flex justify-between items-center">
      <div class="flex flex-col gap-1">
        <h6 class="font-normal text-[10px] text-gray-400">
          {{
            data.status === StatusEnum.COMPLETED
              ? "Approved On:"
              : "Last Updated:"
          }}
        </h6>
        <h6
          class="font-normal text-[9px] text-gray-600"
          :class="{ italic: !data.updated_at }"
        >
          {{
            data.updated_at
              ? moment
                  .tz(data.updated_at, "Asia/Singapore")
                  .format("DD MMM YYYY [-] HH.mm [(GMT +8)]")
              : data.active
              ? "There are no updates yet"
              : "Report fill coming soon"
          }}
        </h6>
      </div>
      <v-btn
        variant="text"
        class="capitalize w-32 text-[11px] font-semibold cursor-default"
        :class="{
          'bg-green-100 text-green-500': data.status === StatusEnum.COMPLETED,
          'bg-orange-100 text-orange-400': data.status === StatusEnum.REVISION,
          'bg-yellow-100 text-orange-400':
            data.status === StatusEnum.WAITING_APPROVAL,
          'bg-blue-100 text-blue-500':
            !data.status && (!isCurrentYear || data.active || data.urgent),
          'bg-gray-100 text-gray-400':
            data.status === StatusEnum.DRAFT ||
            (isCurrentYear && !data.active && !data.urgent),
        }"
      >
        {{
          data.status === StatusEnum.DRAFT
            ? "Draft"
            : data.status === StatusEnum.WAITING_APPROVAL
            ? isPjo
              ? "Need Approval"
              : "Waiting Approval"
            : data.status === StatusEnum.REVISION
            ? "Revision"
            : data.status === StatusEnum.COMPLETED
            ? "Approved"
            : !data.status && (!isCurrentYear || data.active || data.urgent)
            ? "Open"
            : !data.status && isCurrentYear && !data.active && !data.urgent
            ? "Belum tersedia"
            : ""
        }}

        <template v-slot:append v-if="data.status === StatusEnum.COMPLETED">
          <v-icon class="text-green-600 text-sm">
            mdi-check-circle-outline
          </v-icon>
        </template>

        <template
          v-slot:append
          v-else-if="
            !data.status && isCurrentYear && !data.active && !data.urgent
          "
        >
          <img src="../../../assets/icon/lock.png" alt="icon" class="w-4" />
        </template>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardMonthComponent",
  props: {
    isPjo: Boolean,
    data: Object,
    year: Number,
    workArea: String,
  },
  computed: {
    isCurrentYear() {
      return Number(this.year) === new Date().getFullYear();
    },
  },
  methods: {
    goToReport(data) {
      if (this.isCurrentYear && !data.active && !data.urgent) return;

      if (data.id) {
        this.$router.push({
          path: `/esg-report/${this.year}/${data.id_month}/${this.workArea}/${data.id}`,
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          path: `/esg-report/${this.year}/${data.id_month}/${this.workArea}`,
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
